import { V } from "../misc/Vector.js";
import { Trajectory } from "./Trajectory.js";
import { GeometryUtils as G } from "../utils/Geometry.js";
export { CandidateTrajectory };
class CandidateTrajectory extends Trajectory {
    constructor({ tangent, point, direction, rotation, waypoint, center, radius, width, spacing, connection }) {
        super({ waypoint, center, radius, width, spacing, connection });
        this.tangent = tangent;
        this.point = point;
        this.direction = direction;
        this.rotation = rotation !== null && rotation !== void 0 ? rotation : G.rotation(V.subtract(point, center), direction);
    }
    clone() {
        return new CandidateTrajectory({
            tangent: this.tangent,
            point: this.point,
            direction: this.direction,
            rotation: this.rotation,
            waypoint: this.waypoint,
            center: this.center,
            radius: this.radius,
            width: this.width,
            spacing: this.spacing,
            connection: this.connection
        });
    }
    getTangents() {
        return [this.tangent];
    }
}
//# sourceMappingURL=CandidateTrajectory.js.map